<template>
    <div class="ah-page analysis-payout-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>營業支出分析</h1>
                        <el-select v-model="year" placeholder="年度" size="small" no-data-text="無數據" class="title-dropdown" @change="updateData">
                            <el-option v-for="item in yearOptions" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                    <div class="actions">
                        <el-button type="normal" :loading="isLoadingExport" @click="onExport">
                            匯出Excel
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="panel-header gray small">
                    <div class="panel-title">
                        <span>{{ year }} 全年群組分析</span>
                        <ah-tip>
                            請款單
                            <PaymentStatusLabel :statusNum="2" />＋ <PaymentStatusLabel :statusNum="3" /> 總額 ＋ 人事薪資 ＋財務支出（非營業）
                        </ah-tip>
                    </div>
                    <div class="panel-action"></div>
                </div>
                <div class="panel-body">
                    <center style="margin-bottom: 32px">
                        <el-radio-group v-model="groupDataMode" size="small" @change="onGroupDataModeChange">
                            <el-radio-button label="single">單月支出</el-radio-button>
                            <el-radio-button label="sumup">累計支出</el-radio-button>
                        </el-radio-group>
                    </center>
                    <v-chart
                        :option="groupChartOption"
                        style="
                            width: 90%;
                            height: 200px;
                            margin-top: 20px;
                            margin-bottom: 20px;
                            margin-left: auto;
                            margin-right: auto;
                        "
                        ref="groupChart"
                    />
                    <div
                        style="
                            width: 95%;
                            margin-top: 15px;
                            color: #666;
                            font-size: 10pt;
                            text-align: right;
                        "
                    ></div>
                </div>
                <div class="ah-panel">
                    <div class="panel-header gray small">
                        <div class="panel-title">
                            <span>{{ year }} 支出群組分析</span>
                        </div>
                        <div class="panel-action">
                            <el-select v-model="month" placeholder="月份" size="small" no-data-text="無數據" style="vertical-align: top; width: 120px" @change="updateData">
                                <el-option v-for="item in monthOptions" :key="item.key" :label="item.value" :value="item.key" />
                            </el-select>
                        </div>
                    </div>
                    <div class="panel-body">
                        <el-row :gutter="20">
                            <el-col :sm="10">
                                <v-chart :option="pieChartOption" style="width: 100%; height: 350px" />
                            </el-col>
                            <el-col :sm="14">
                                <el-table :data="pageData.subTotals" style="width: 100%" border size="small" class="ah-analysis-table">
                                    <el-table-column prop="name" label="支出項目群組">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.name == '合計'" class="item-name no-link" style="font-size: 10.5pt">{{ scope.row.name }}</span>
                                            <span v-else class="item-name" style="font-size: 10.5pt; cursor: pointer" @click="onClickMainItem(scope.row.name)" @keydown="() => {}">{{
                                                scope.row.name
                                            }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="amount" label="含稅總額" align="right">
                                        <template slot-scope="scope">
                                            <Money :v="scope.row.amount" style="font-size: 10pt" round />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="percent" label="%" align="right" width="95">
                                        <template slot-scope="scope">
                                            <div style="font-size: 10pt">
                                                {{ Math.round(scope.row.percent * 1000) / 10 }}
                                                %
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header small gray" id="analysis-payout-barchart">
                    <div class="panel-title">{{ year }} 全年子項目分析</div>
                    <div class="panel-action">
                        <el-radio-group v-model="isSubDataZeroExcluded" size="small" @change="onSubDataFilterChange">
                            <el-radio-button :label="false">全部項目</el-radio-button>
                            <el-tooltip content="只顯示整年度有金額變化的項目" placement="top">
                                <el-radio-button :label="true"> 有效項目 </el-radio-button>
                            </el-tooltip>
                        </el-radio-group>
                    </div>
                </div>
                <div class="panel-body" style="margin: 0 20px; min-height: 700px">
                    <center style="margin-bottom: 32px">
                        <el-radio-group v-model="subDataMode" size="small" @change="onSubDataModeChange">
                            <el-radio-button label="single">單月支出</el-radio-button>
                            <el-radio-button label="sumup">累計支出</el-radio-button>
                            <el-radio-button label="percent">全年佔比</el-radio-button>
                        </el-radio-group>
                    </center>
                    <el-tabs v-model="activeTabName" @tab-click="updateAllSubDataDisplay">
                        <el-tab-pane v-for="item in tabList" :key="item.sno" :label="item.name" :name="`${item.sno}`"> </el-tab-pane>
                    </el-tabs>

                    <div v-if="subDataMode === 'single' || subDataMode === 'sumup'">
                        <v-chart
                            :option="subChartOption"
                            style="
                                width: 90%;
                                height: 200px;
                                margin-top: 20px;
                                margin-bottom: 50px;
                                margin-left: auto;
                                margin-right: auto;
                            "
                            ref="subChart"
                            key="subChart"
                        />
                        <el-table :data="subTableData" class="ah-analysis-table" border size="small" :show-summary="true" :summary-method="getSummaries">
                            <el-table-column prop="name" label="子項目" align="left" min-width="120"> </el-table-column>
                            <el-table-column v-for="m in 12" :key="m" :prop="`m${m}`" :label="`${m} 月`" align="right">
                                <template slot-scope="scope">
                                    <div>
                                        <Money :v="scope.row[`m${m}`]" zero="-" round style="font-weight: 400" />
                                    </div>
                                    <div v-if="subDataMode === 'sumup' && m > 0" style="color: #009911">
                                        <span v-if="scope.row[`m${m}`] - scope.row[`m${m - 1}`] > 0">
                                            +
                                            <Money :v="scope.row[`m${m}`] - scope.row[`m${m - 1}`]" round style="font-weight: 400" />
                                        </span>
                                        <span v-else> - </span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="total" label="合計" align="right">
                                <template slot-scope="scope">
                                    <Money :v="scope.row.total" zero="-" round />
                                </template>
                            </el-table-column>
                            <el-table-column prop="percent" label="%" align="right" width="65">
                                <template slot-scope="scope">
                                    <div style="font-size: 9pt">{{ scope.row.percent }}%</div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 15px; color: #666; font-size: 10pt"></div>
                    </div>
                    <div v-if="subDataMode === 'percent'">
                        <el-row :gutter="20">
                            <el-col :sm="10">
                                <v-chart :option="subPieChartOption" style="width: 100%; height: 350px" ref="subPieChart" key="subPieChart" />
                            </el-col>
                            <el-col :sm="14">
                                <el-table :data="subPieTableData" style="width: 100%" border size="small" class="ah-analysis-table">
                                    <el-table-column prop="name" label="子項目">
                                        <template slot-scope="scope">
                                            <span class="item-name" style="font-size: 10.5pt">{{ scope.row.itemName }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="amount" label="含稅總額" align="right">
                                        <template slot-scope="scope">
                                            <Money :v="scope.row.amount" style="font-size: 10pt" round />
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="percent" label="%" align="right" width="95">
                                        <template slot-scope="scope">
                                            <div style="font-size: 10pt">{{ scope.row.percent }}%</div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import { monthOptions } from '@/assets/commonData/options';
import PaymentStatusLabel from '@/components/dashboard/Payment/PaymentStatusLabel.vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';
import mixins from './PayoutExportMixin';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent]);
export default {
    mixins: [mixins],
    name: 'AnalysisPayout',
    components: {
        PaymentStatusLabel,
        VChart,
    },
    data() {
        return {
            type: 1,
            tabList: [],
            activeTabName: null,
            pageData: {
                subTotals: null,
                analysisGroups: null,
            },
            subTableData: [],
            subPieTableData: [],
            isSubDataZeroExcluded: true,
            groupDataMode: 'sumup', // 'single' | 'sumup'
            subDataMode: 'single', // 'single' | 'sumup' | 'percent'
            year: null,
            month: 0,
            yearOptions: [],
            monthOptions: [{ key: 0, value: '全年' }, ...monthOptions],
            pieChartOption: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    display: false,
                    orient: 'vertical',
                    left: 'bottom',
                    data: [],
                },
                series: [
                    {
                        name: '支出總額',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        center: ['50%', '50%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            },
            isLoadingExport: false,
            groupChartOption: {
                tooltip: {
                    trigger: 'axis',
                    position(point, params, dom, rect, size) {
                        const pointX = point[0];
                        const pointY = point[1];

                        const boxWidth = size.contentSize[0];
                        const boxHeight = size.contentSize[1];

                        const x = pointX + 20;
                        const y = pointY - boxHeight / 2;
                        return [x, y];
                    },
                },
                backgroundColor: 'transparent',
                grid: {
                    top: 70,
                    left: 0,
                    bottom: 0,
                    right: 15,
                    containLabel: true,
                },
                legend: {
                    data: [],
                },
                dataset: { source: [] },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(0,0,0,0.1)',
                            width: 1,
                            type: 'solid',
                        },
                    },
                },
                series: [],
            },
            subChartOption: {
                tooltip: {
                    trigger: 'axis',
                },
                backgroundColor: 'transparent',
                grid: {
                    top: 70,
                    left: 0,
                    bottom: 0,
                    right: 15,
                    containLabel: true,
                },
                legend: {
                    data: [],
                },
                dataset: { source: [] },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            color: 'rgba(0,0,0,0.1)',
                            width: 1,
                            type: 'solid',
                        },
                    },
                },
                series: [],
            },
            subPieChartOption: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b} : {c} ({d}%)',
                },
                legend: {
                    display: false,
                    orient: 'vertical',
                    left: 'bottom',
                    data: [],
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['40%', '60%'],
                        center: ['50%', '50%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            },
        };
    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            await this.fetchYearOptions();
            await this.updateData();
        },
        async fetchYearOptions() {
            const resp = await this.$api({
                url: 'FinancialAnalysisPage/GetPayoutAnalysisYearOptions',
                method: 'GET',
            });
            resp.data.yearOptions.sort((a, b) => b - a);

            if (resp.data.yearOptions && resp.data.yearOptions.length > 0) {
                this.yearOptions = resp.data.yearOptions;
            } else {
                this.yearOptions = [new Date().getFullYear()];
            }
            this.year = _.head(this.yearOptions);
        },
        async updateData() {
            this.isLoadingExport = true;
            const result = await this.$api({
                url: 'FinancialAnalysisPage/GetPayoutAnalysis',
                params: {
                    Type: this.type,
                    specificYear: this.year,
                },
                method: 'GET',
            });

            console.log('GetPayoutAnalysis', result.data);

            const { subtotals, analysisGroups } = result.data;

            this.pageData.analysisGroups = analysisGroups;

            this.updateMainData(subtotals, analysisGroups);
            this.updateSubData(analysisGroups);

            this.isLoadingExport = false;
        },
        updateMainData(subtotals, analysisGroups) {
            if (this.month) {
                // 有指定月份
                const data = subtotals;
                this.pageData.subTotals = _.chain(data)
                    .find(['month', this.month])
                    .get('groupInfos')
                    .value();
            } else {
                // 無指定月份（全年）
                const data = analysisGroups;
                const mappedData = _.chain(data)
                    .map((o) => ({
                        name: o.groupName,
                        amount: _.sumBy(o.itemInfos, 'amount'),
                    }))
                    .value();
                const sum = _.sumBy(mappedData, 'amount');
                this.pageData.subTotals = _.map(mappedData, (o) => ({
                    ...o,
                    percent: sum ? o.amount / sum : 0,
                }));
            }

            this.updateGroupChart();
            this.updatePieChart();

            // 合計
            this.pageData.subTotals.push({
                name: '合計',
                percent: 1,
                amount: Math.round(_.sumBy(this.pageData.subTotals, 'amount')),
                tax: Math.round(_.sumBy(this.pageData.subTotals, 'tax')),
            });
        },
        updateGroupChart() {
            if (!this.pageData.analysisGroups) {
                this.groupChartOption.legend.data = [];
                this.groupChartOption.series = [];
                return;
            }

            const series = [];
            const legendData = [];

            // 每個大群組
            this.pageData.analysisGroups.forEach((g) => {
                const gDatas = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                let isAllZero = true;
                // 每個子項目
                g.itemInfos.forEach((item) => {
                    // 每個月
                    for (let m = 0; m < 12; m += 1) {
                        if (item.monthlyInfos[m]) {
                            const value = Math.round(item.monthlyInfos[m].amount);
                            gDatas[m] += value;

                            if (value !== 0) isAllZero = false;
                        }
                    }
                });

                if (!isAllZero) {
                    series.push({
                        name: g.groupName,
                        type: 'line',
                        animation: false,
                        data: gDatas,
                    });

                    legendData.push(g.groupName);
                }
            });

            // 累計模式
            if (this.groupDataMode === 'sumup') {
                for (let s = 0; s < series.length; s += 1) {
                    const se = series[s];
                    for (let m = 1; m < 12; m += 1) {
                        se.data[m] = se.data[m - 1] + se.data[m];
                    }
                }
            }

            if (moment().year() === this.year) {
                series.forEach(({ data }) => {
                    const DATA = data;
                    for (let i = 0; i < data.length; i += 1) {
                        for (let m = moment().month() + 1; m <= 12; m += 1) {
                            DATA[m] = null;
                        }
                    }
                });
            }
            this.groupChartOption.legend.data = legendData;
            this.groupChartOption.series = series;
        },
        updatePieChart() {
            const items = this.pageData.subTotals.map((item) => {
                this.pieChartOption.legend.data.push(item.name);
                return {
                    value: Math.round(item.amount),
                    name: item.name,
                };
            });
            this.pieChartOption.series[0].data = items.filter((x) => x.value !== 0);
        },
        updateSubData(data) {
            this.tabList = _.map(data, (o) => ({
                name: o.groupName,
                sno: `${o.groupSNO}`,
            }));
            if (this.activeTabName === '0') {
                this.activeTabName = _.head(this.tabList).sno;
            }
            this.updateAllSubDataDisplay();
        },
        updateAllSubDataDisplay() {
            this.updateSubTableData();
            if (this.subDataMode === 'single' || this.subDataMode === 'sumup') {
                this.updateSubChart();
            } else if (this.subDataMode === 'percent') {
                this.updateSubPieChart();
            }
        },
        updateSubTableData() {
            let analysisGroups = JSON.parse(JSON.stringify(this.pageData.analysisGroups));

            if (this.isSubDataZeroExcluded) {
                analysisGroups = this.excludeZeroSubItems(this.pageData.analysisGroups);
            }

            const group = analysisGroups.find((x) => x.groupSNO === Number(this.activeTabName));

            // for single & sumup table
            const datas = [];
            let totalAmount = 0;
            if (group) {
                totalAmount = _.sumBy(group.itemInfos, 'amount');
                group.itemInfos.forEach((item) => {
                    datas.push({
                        name: item.itemName,
                        m1: item.monthlyInfos[0].amount,
                        m2: item.monthlyInfos[1].amount,
                        m3: item.monthlyInfos[2].amount,
                        m4: item.monthlyInfos[3].amount,
                        m5: item.monthlyInfos[4].amount,
                        m6: item.monthlyInfos[5].amount,
                        m7: item.monthlyInfos[6].amount,
                        m8: item.monthlyInfos[7].amount,
                        m9: item.monthlyInfos[8].amount,
                        m10: item.monthlyInfos[9].amount,
                        m11: item.monthlyInfos[10].amount,
                        m12: item.monthlyInfos[11].amount,
                        total: item.amount,
                        percent: Math.round((item.amount / totalAmount) * 1000) / 10,
                    });
                });
            }

            if (this.subDataMode === 'sumup') {
                for (let i = 0; i < datas.length; i += 1) {
                    for (let m = 2; m <= 12; m += 1) {
                        datas[i][`m${m}`] = datas[i][`m${m - 1}`] + datas[i][`m${m}`];
                    }
                }
            }

            // 去除未來日期資料
            if (moment().year() === this.year) {
                for (let i = 0; i < datas.length; i += 1) {
                    for (let m = moment().month() + 2; m <= 12; m += 1) {
                        datas[i][`m${m}`] = null;
                    }
                }
            }

            this.subTableData = datas;

            // for percent pie table
            const percentDatas = [];
            if (group) {
                group.itemInfos.forEach((item) => {
                    percentDatas.push({
                        itemName: item.itemName,
                        amount: item.amount,
                        percent: Math.round((item.amount / totalAmount) * 1000) / 10,
                    });
                });
                percentDatas.push({
                    itemName: '合計',
                    amount: totalAmount,
                    percent: 100,
                });
            }
            this.subPieTableData = percentDatas;
        },
        updateSubPieChart() {
            const seriesData = [];
            this.subTableData.forEach((item) => {
                seriesData.push({
                    value: item.total,
                    name: item.name,
                });
            });
            this.subPieChartOption.series[0].data = seriesData;
        },
        updateSubChart() {
            if (!this.subTableData) {
                this.subChartOption.legend.data = [];
                this.subChartOption.series = [];
                return;
            }

            const series = [];
            const legendData = [];

            this.subTableData.forEach((item) => {
                const data = [];
                for (let i = 1; i <= 12; i += 1) {
                    data.push(item[`m${i}`]);
                }

                series.push({
                    name: item.name,
                    type: 'line',
                    animation: false,
                    data,
                });

                legendData.push(item.name);
            });

            const newChartOption = JSON.parse(JSON.stringify(this.subChartOption));
            this.subChartOption.legend.data = [];
            this.subChartOption.series = [];
            this.$refs.subChart.clear();

            newChartOption.legend.data = legendData;
            newChartOption.series = series;

            this.subChartOption = newChartOption;
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '總計';
                    return;
                }
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => Number.isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!Number.isNaN(value)) {
                            return prev + curr;
                        }
                        return prev;
                    }, 0);
                    sums[index] = Math.round(sums[index]).toLocaleString('en-US');
                } else {
                    sums[index] = 'N/A';
                }
            });

            sums[14] = '100%';
            return sums;
        },
        excludeZeroSubItems(data) {
            const newData = [];
            data.forEach((group) => {
                const newGroup = JSON.parse(JSON.stringify(group));
                newGroup.itemInfos = [];
                group.itemInfos.forEach((item) => {
                    let isAllZero = true;
                    item.monthlyInfos.forEach((itemMonthData) => {
                        if (itemMonthData.amount !== 0) isAllZero = false;
                    });

                    if (!isAllZero) newGroup.itemInfos.push(item);
                });
                newData.push(newGroup);
            });
            return newData;
        },

        onSubDataFilterChange() {
            this.updateAllSubDataDisplay();
        },
        onSubDataModeChange() {
            this.updateAllSubDataDisplay();
        },
        onGroupDataModeChange() {
            this.updateGroupChart();
        },
        onClickMainItem(itemName) {
            const found = _.find(this.tabList, (o) => o.name === itemName);
            if (found) {
                this.activeTabName = found.sno;
                this.updateAllSubDataDisplay();
                this.scrollToBarchartSection();
            }
        },
        scrollToBarchartSection() {
            document.getElementById('analysis-payout-barchart').scrollIntoView({
                behavior: 'smooth',
            });
        },
    },
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.analysis-payout-page {
    .total-table {
        td {
            padding: 0;
        }

        .item-name {
            display: inline-block;
            font-size: 11pt;
            font-weight: bold;
            cursor: pointer;
            padding: 6px 0;

            &:hover {
                color: $main-color;
            }

            &.no-link {
                &:hover {
                    color: #444;
                }
            }
        }
    }
    .ah-analysis-table.el-table {
        th, td {
            padding: 5px 0;
        }
    }
}
</style>
